export default __webpack_public_path__ + "static/media/Azure.6fce31a1.svg";